// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payment-icon{width:auto}.payment-icon--sm{height:20px}.payment-icon--lg{height:120px}", ""]);
// Exports
module.exports = exports;
